module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-mobile.c07ad117.png";